<template>
  <button v-bind="$attrs" class="base-button">
    <slot />
  </button>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    backgroundColor: { type: String, default: "grey" },
    textColor: { type: String, default: "black" },
    borderRadius: { type: [String, Number], default: "0.5" },
    paddingVertical: { type: [String, Number], default: "15" },
    paddingHorizonal: { type: [String, Number], default: "15" },
    marginVertical: { type: [String, Number], default: "15" },
    marginHorizonal: { type: [String, Number], default: "15" },
    fontSize: { type: [String, Number], default: "16" },
  },
  computed: {
    rounded() {
      return `${this.borderRadius}px`;
    },
    paddingX() {
      return `${this.paddingHorizonal}px`;
    },
    paddingY() {
      return `${this.paddingVertical}px`;
    },
    marginX() {
      return `${this.marginHorizonal}px`;
    },
    marginY() {
      return `${this.marginVertical}px`;
    },
    fontSizeProp() {
      return `${this.fontSize}px`
    }
  },
};
</script>

<style lang="css" scoped>
.base-button {
  background-color: v-bind("backgroundColor");
  border: none;
  color: v-bind("textColor");
  padding-inline: v-bind("paddingX");
  padding-block: v-bind("paddingY");
  margin-inline: v-bind("marginX");
  margin-block: v-bind("marginY");
  text-align: center;
  text-decoration: none;
  display: inline-block;
  border-radius: v-bind("rounded");
  cursor: pointer;
  font-size: v-bind("fontSizeProp");
  opacity: 1;
  transition: all 0.2s;
  filter: drop-shadow(0.5rem 0.3rem 0.5rem #0000004b);
}
.base-button:hover {
  opacity: 0.75;
}
</style>
